import React, { ReactElement, ReactNode } from "react";
import Head from "next/head";
import colors from "@styles/variables/wideformatprintercostsVariables.module.scss";
import WideFormatPrinterCostsLogo from "@components/wideformatprintercosts/logo";
import { useModal } from "@hooks/useModalContext";
import dynamic from "next/dynamic";
import Header from "@components/shared/header";
import style from "./layouts.module.scss";
import Mobile from "@components/shared/blogPost/sideWidget/mobile";

const CloseIcon = dynamic(() => import("@components/svg/closeIcon"));
const Modal = dynamic(() => import("@components/shared/modal"));

const TermsAndConditions = dynamic(
    () => import("@components/shared/legal/termsAndConditions"),
);
const PrivacyPolicy = dynamic(
    () => import("@components/shared/legal/privacyPolicy"),
);

const Footer = dynamic(() => import("@components/shared/footer"));

export default function WideFormatPrinterCostsWrapper({
    children,
}: {
    children: ReactNode;
}): ReactElement {
    const { modal, closeModal } = useModal();

    const handleClose = () => {
        closeModal();
    };

    const { active: modalActive, content: modalContent } = modal;

    const getModalContent = () => {
        switch (modalContent) {
            case "privacy":
                return (
                    <PrivacyPolicy
                        category="Wide Format Printers"
                        domain="WideFormatPrinterCosts.com"
                    />
                );
            case "terms":
                return (
                    <TermsAndConditions
                        category="Wide Format Printers"
                        domain="WideFormatPrinterCosts.com"
                    />
                );
            case "sideWidget":
                return <Mobile />;
            default:
                return null;
        }
    };

    return (
        <>
            <Head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap"
                    rel="stylesheet"
                />
            </Head>
            <Header
                textColor={colors.offerCallNumber}
                slogan=" find the best wide format printer prices"
            >
                <WideFormatPrinterCostsLogo />
            </Header>
            <div style={{ fontFamily: `'Open Sans', sans-serif` }}>
                <div className="relative w-screen">
                    <div className={style["wideformatprintercosts-gradient"]}>
                        {children}
                    </div>

                    <Footer />
                </div>
                <Modal
                    onClose={handleClose}
                    active={modalActive}
                    closeIcon={<CloseIcon />}
                    backdropClosable
                    modalStyles={{
                        display: "flex",
                        flexDirection: "column",
                        maxHeight:
                            modalContent === "sideWidget" ? "80vh" : "100%",
                    }}
                    modalClassName="h-[90vh] rounded"
                    bodyStyles={{ overflowY: "scroll" }}
                    width={900}
                    header={
                        modalContent === "privacy"
                            ? "Privacy Policy"
                            : modalContent === "terms"
                            ? "Terms and Conditions"
                            : modalContent === "sideWidget"
                            ? "Contents"
                            : undefined
                    }
                >
                    {getModalContent()}
                </Modal>
            </div>
        </>
    );
}
